<div class="mb-[20px] flex items-center justify-between">
  <div class="flex grow justify-end">
    <aux-export-excel-button
      [clickFN]="onExport.bind(this)"
      [spinnerSize]="7"
      pendoTag="user-permissions-excel-export-button"
    />
  </div>
</div>

@if (
  {
    gridData: gridData$ | async,
    gridOptions: gridOptions$ | async,
  };
  as obj
) {
  @if (!loading()) {
    <ag-grid-angular
      domLayout="autoHeight"
      class="ag-theme-aux user-permissions-table mb-16 tabular-nums"
      [gridOptions]="obj.gridOptions || undefined"
      (gridReady)="gridReady($event)"
      [rowData]="obj.gridData"
      auxStickyGrid
    />
  }

  @if (loading()) {
    <aux-table-skeleton />
  }
}

<!-- Save changes -->
@if (changedValues.length) {
  <aux-save-changes
    [onSaveChanges]="onSaveChanges"
    [showDiscardChangesBtn]="true"
    (cancel)="onDiscardChanges()"
  />
}
